/* tslint:disable */
/* eslint-disable */
/**
 * Trendtours CMS API
 * ISO API for the IBE. 
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ApiBrochureSubscriptionResponse
 */
export interface ApiBrochureSubscriptionResponse {
    /**
     * 
     * @type {boolean}
     * @memberof ApiBrochureSubscriptionResponse
     */
    success: boolean;
}

export function ApiBrochureSubscriptionResponseFromJSON(json: any): ApiBrochureSubscriptionResponse {
    return ApiBrochureSubscriptionResponseFromJSONTyped(json, false);
}

export function ApiBrochureSubscriptionResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiBrochureSubscriptionResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'success': json['success'],
    };
}

export function ApiBrochureSubscriptionResponseToJSON(value?: ApiBrochureSubscriptionResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'success': value.success,
    };
}


// custom code here ##################################################################################################################
function toUTC(date) {
  var date_utc =  Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds());
  return new Date(date_utc);
}
